export default function ServiceCard({ service }) {
  return (
    <div className="service-card h-100">
      <div className="service-icon"><i className={`bi ${service.icon}`}></i></div>
      <h4>{service.title}</h4>
      <p>{service.short}</p>
      <ul className="list-unstyled mt-3 mb-0">
        {service.details.map((item) => (
          <li key={item} className="service-point"><i className="bi bi-check-circle-fill me-2"></i>{item}</li>
        ))}
      </ul>
    </div>
  );
}
